






































import { Component, Prop } from 'vue-property-decorator'

import DrawerWidthMixin from '../../../../../../../../../logic/helpers/DrawerWidthMixin'
import CustomEditor from '../../../../../Editor/CustomEditor'
import { ActionNode } from '../../logic/ActionNode'
import { ActionTypes } from '../../logic/Actions/types'
import ActionNodeActions from './Actions/ActionNodeActions.vue'
import AddingAction from './Actions/AddingAction.vue'

@Component({
  components: {
    ActionNodeActions,
    AddingAction,
  }
})
export default class ActionNodeSidebar extends DrawerWidthMixin {
  @Prop() node!: ActionNode

  @Prop() editor!: CustomEditor

  isOpen = false

  addAction(type: ActionTypes): void {
    this.node.data.addAction(type)
    this.isOpen = false
  }

  removeAction(proxy: any): void {
    this.node.data.removeAction(proxy)
  }
}
